module.exports = __webpack_public_path__ + "img/mobile-shortage-modal-img.9829628f.svg";